// T4/100A01: Interruptores de interfaz por variable .env del frontend.
// SIN la variable el comportamiento es exactamente el original (producción no
// tiene el .env del usuario).
//   REACT_APP_UI_SIDEBAR_COLAPSABLE=true  menú lateral que se oculta y queda como
//                                         barra de iconos; también en los submódulos.
export const readFlag = (value) => String(value ?? "").trim().toLowerCase() === "true";

export const SIDEBAR_COLLAPSIBLE = readFlag(process.env.REACT_APP_UI_SIDEBAR_COLAPSABLE);

// T2/100A39: desglose de materiales de la cotización con producto del Price book,
// cantidad neta en unidad de uso y presentaciones completas. Sin la variable el
// desglose es el original (texto + valor).
//   REACT_APP_COTIZACION_DESGLOSE_UNIDADES=true
export const COTIZACION_DESGLOSE_UNIDADES = readFlag(process.env.REACT_APP_COTIZACION_DESGLOSE_UNIDADES);

// T2/100A66: en la barra superior, el interruptor "Favorita / No favorita" (MarkerSwitch) se
// reemplaza por el botón "Fuente de datos" (solo lo ven los superusuarios). Sin la variable
// la barra es la original.
//   REACT_APP_UI_DATASOURCE_SWITCH=true
// T2/100A77: retirado junto con la fuente de datos del backend (todo es la base local). Antes:
// export const UI_DATASOURCE_SWITCH = readFlag(process.env.REACT_APP_UI_DATASOURCE_SWITCH);
export const UI_DATASOURCE_SWITCH = false;

// T2/100A73: submódulo Gestion Compras › Bodegas (mosaico y pantalla). Necesita el backend con
// COMPRAS_BODEGAS_V2=on. Sin la variable el menú y las rutas quedan como antes.
//   REACT_APP_COMPRAS_BODEGAS_V2=true
// T2/100A96: Bodegas v2 siempre activo (se trabaja solo con el módulo nuevo de Compras). Antes:
// export const COMPRAS_BODEGAS_V2 = readFlag(process.env.REACT_APP_COMPRAS_BODEGAS_V2);
export const COMPRAS_BODEGAS_V2 = true;

// T3/100A04: bloqueo por URL de los módulos sin permiso (components/Permisos/RouteGuard.js).
// Sin la variable, cualquier URL abre como antes.
//   REACT_APP_SEC_ROUTE_GUARD=true
// T3/100A05: en desarrollo (npm start) el bloqueo queda ENCENDIDO sin variable; en el build de
// producción sigue dependiendo de la variable (activarlo allí lo decide Evaldo en el PR).
// REACT_APP_SEC_ROUTE_GUARD=false lo apaga. Antes:
// export const SEC_ROUTE_GUARD = readFlag(process.env.REACT_APP_SEC_ROUTE_GUARD);
const ROUTE_GUARD_VAR = process.env.REACT_APP_SEC_ROUTE_GUARD;
export const SEC_ROUTE_GUARD =
  ROUTE_GUARD_VAR === undefined || String(ROUTE_GUARD_VAR).trim() === ""
    ? process.env.NODE_ENV === "development"
    : readFlag(ROUTE_GUARD_VAR);
